'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Column_web_styles = require('./Column.web.styles.cjs');

/**
 * Description added in Columns.web.tsx
 *
 */ const Column = ({ columnWidth = 12, textAlign = "left", children, phoneWidth = 12, tabletWidth, customCss, ...rest })=>{
    const columnStyles = [
        Column_web_styles.column,
        Column_web_styles.sizes(columnWidth, phoneWidth),
        tabletWidth && Column_web_styles.tabletSize(tabletWidth),
        textAlign && Column_web_styles.textAlignment(textAlign),
        customCss
    ];
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: columnStyles,
        ...rest,
        children: children
    });
};

exports.Column = Column;
//# sourceMappingURL=Column.web.cjs.map
